export class FargoFromPrintOriginAttributesDB {

    public static originAttributes = [
        "cardSerialNumber"
    ]
}